import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon, obj = logged in

  useEffect(() => {
    let mounted = true;
    api.get("/auth/me")
      .then((res) => mounted && setUser(res.data))
      .catch(() => mounted && setUser(null));
    return () => { mounted = false; };
  }, []);

  const login = async (email, password) => {
    try {
      const res = await api.post("/auth/login", { email, password });
      if (res.data?.token) setAuthToken(res.data.token);
      setUser(res.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
